/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Faq_Contents_DetailInputs */

const en_marketing_faq_contents_detail = /** @type {(inputs: Marketing_Faq_Contents_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The complete repository: the application, the docs site, every package, the Playwright and Vitest suites, and the CI pipeline. It runs locally with one command.`)
};

const es_marketing_faq_contents_detail = /** @type {(inputs: Marketing_Faq_Contents_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El repositorio completo: la aplicación, el sitio de documentación, todos los paquetes, las suites de Playwright y Vitest, y el pipeline de CI. Se ejecuta en local con un solo comando.`)
};

const fr_marketing_faq_contents_detail = /** @type {(inputs: Marketing_Faq_Contents_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le dépôt complet : l'application, le site de documentation, tous les paquets, les suites Playwright et Vitest, et le pipeline CI. Il tourne en local avec une seule commande.`)
};

/**
* | output |
* | --- |
* | "The complete repository: the application, the docs site, every package, the Playwright and Vitest suites, and the CI pipeline. It runs locally with one command." |
*
* @param {Marketing_Faq_Contents_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_faq_contents_detail = /** @type {((inputs?: Marketing_Faq_Contents_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Faq_Contents_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_faq_contents_detail(inputs)
	if (locale === "es") return es_marketing_faq_contents_detail(inputs)
	return fr_marketing_faq_contents_detail(inputs)
});